;(function ($) {


    function initAnimations() {
        $('.js-animated-item:in-viewport').each(function () {
            var delayTime = $(this).data('animation-delay')

            $(this).delay(delayTime).queue(function () {
                $(this).addClass('is-animated')
            })
        })
    }

    initAnimations()
    $(window).scroll(initAnimations)


})(jQuery);
